import { badgeClasses } from '@mui/material/Badge';
import { createComponentOverrides } from '../theme/create-component-overrides';
export var createMuiBadgeOverrides = createComponentOverrides(function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var tokens = _a.tokens;
    return ({
        defaultProps: {
            color: 'default',
        },
        variants: [
            {
                props: { color: 'default' },
                style: (_b = {},
                    _b["& .".concat(badgeClasses.badge)] = {
                        backgroundColor: tokens.color_bg_state_neutral,
                        color: tokens.color_fg_on_state_neutral,
                    },
                    _b),
            },
            {
                props: { color: 'success' },
                style: (_c = {},
                    _c["& .".concat(badgeClasses.badge)] = {
                        backgroundColor: tokens.color_bg_state_success,
                        color: tokens.color_fg_on_state_success,
                    },
                    _c),
            },
            {
                props: { color: 'info' },
                style: (_d = {},
                    _d["& .".concat(badgeClasses.badge)] = {
                        backgroundColor: tokens.color_bg_state_info,
                        color: tokens.color_fg_on_state_info,
                    },
                    _d),
            },
            {
                props: { color: 'warning' },
                style: (_e = {},
                    _e["& .".concat(badgeClasses.badge)] = {
                        backgroundColor: tokens.color_bg_state_caution,
                        color: tokens.color_fg_on_state_caution,
                    },
                    _e),
            },
            {
                props: { color: 'danger' },
                style: (_f = {},
                    _f["& .".concat(badgeClasses.badge)] = {
                        backgroundColor: tokens.color_bg_state_danger,
                        color: tokens.color_fg_on_state_danger,
                    },
                    _f),
            },
            {
                props: { color: 'primary' },
                style: (_g = {},
                    _g["& .".concat(badgeClasses.badge)] = {
                        backgroundColor: tokens.color_bg_brand_primary,
                        color: tokens.color_fg_on_brand_primary,
                    },
                    _g),
            },
        ],
    });
});
